import React, { useRef } from "react";
import { message } from "antd";
import { YHDrawer } from "@/components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";
import { getFormValidatorErrText, momentFormat, momentFormats } from "@/utils/utils";
import { useWorkshopQueryModel } from "../../workshopQuery/workshopQueryModel";
import useGlobalModel, { transOptions } from "@/model/globalModel";
import moment from "moment";
import { useHistoryQueryModel } from "../historyQueryModel";

//结算
export function ChangeDispatchDrawer() {
    const { technicianData } = useGlobalModel()

    const { changeDispatchVisible: visible,
        detailType,
        selectedRow,
        setSelectedRow, setSelectedRowKeys,
        changedispatch,
        setChangeDispatchVisible } = useHistoryQueryModel();
    const formRef = useRef<IYhFormRef>();

    const onCancel = () => {
        setChangeDispatchVisible(false);
        setSelectedRow({});
        setSelectedRowKeys([]);
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then(async res => {
            let { technicianCodes } = res
            // 按照选择顺序获取技师信息
            const orderedTechnicians = technicianCodes.map((code: string) =>
                technicianData.find((el: any) => el.code === code)
            ).filter(Boolean);
            let newRes = {
                ...res,
                id: selectedRow?.id,
                technicianCodes: technicianCodes.join(','),
                technicianNames: orderedTechnicians.map((item: any) => item.name).join(','),
            }

            let retData = await changedispatch(newRes);
            if (retData) {
                message.success("变更维修工成功");
            }
            else {
                message.error("变更维修工失败");
            }
            onCancel();
        }).catch(err => {
            message.warning(getFormValidatorErrText(err))
        })
    }

    const onFinish = (val: any) => {

    }
    const formConfig: IYhForm<any> = {
        formRef,
        disabled: detailType === "look",
        onFinish,
        formValues: {
            ...selectedRow, technicianCodes: selectedRow?.technicianCodes ? selectedRow.technicianCodes.split(",") : [],
            expectedCompletionTime: selectedRow?.expectedCompletionTime ? momentFormats(selectedRow.expectedCompletionTime) : null,
        },
        labelCol: { span: 6 },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "工单单号",
                fieldName: "maintenanceCode",
                span: 24,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车牌号",
                fieldName: "licensePlate",
                span: 24,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "底盘号",
                fieldName: "vin",
                span: 24,
                disable: true
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "维修技师",
                fieldName: "technicianCodes",
                rules: [{ required: true, message: "请输入维修技师" }],
                allowClear: true,
                mode: "multiple",
                span: 24,
                options: transOptions(technicianData)
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "预计完工时间",
                fieldName: "expectedCompletionTime",
                span: 24,
                disable: true
            },
        ]
    };
    return (
        <YHDrawer
            {...{
                title: '车间主任派工',
                visible,
                onCancel,
                okText: "保存",
                onOk: onSubmit,
                width: 600,
                showFooter: detailType !== "look",
            }}
        >
            <YhForm {...formConfig} />
        </YHDrawer>
    )
}
